import React, {useContext} from 'react';
import './ProfileSummary.less';
import {UserName} from 'elements/user-name/UserName';
import {Chip} from 'elements/chip/Chip';
import {Stat} from '../stat/Stat';
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";

export const ProfileSummary = ({
																 userName,
																 isShowCashpoints,
																 cashpointsAmount = 0,
																 cashpointsName,
																 ordersCount,
																 onUserNameClick,
																 onOffersClick,
																 onCashpointsClick,
																 onOrdersClick,
															 }) => {
	const translations = useContext(TranslationsContext);

	return (
		<div className="profile-summary">
			<div className="profile-summary__name" onClick={onUserNameClick}>
				<UserName text={userName} isClickable={!!onUserNameClick}/>
			</div>
			<div className="profile-summary__offers">
				<Chip isPrimary
							text={getSafeTranslation('ProfileSummary.myOffersCaption', translations)}
							onClick={onOffersClick}
				/>
			</div>
			<div className="profile-summary__container">
				{
					isShowCashpoints && (
						<span className="profile-summary__cashpoints" onClick={onCashpointsClick}>
                    <Stat number={cashpointsAmount} caption={cashpointsName} isClickable/>
                  </span>
					)
				}
				<span className="profile-summary__orders" onClick={onOrdersClick}>
          <Stat
						number={ordersCount}
						caption={getSafeTranslation('ProfileSummary.ordersLabel', translations)}
						isClickable
					/>
        </span>
			</div>
		</div>
	);
};
